// Simple localStorage-based setting for geolocation tagging in watermark (global only)
const GEO_GLOBAL_KEY = "fuel:wm:geo:enabled"; // 'true' | 'false'

export function getGlobalGeoEnabled() {
  try {
    const v = localStorage.getItem(GEO_GLOBAL_KEY);
    if (v === null) return false; // default OFF
    return v === "true";
  } catch {
    return true;
  }
}

export function setGlobalGeoEnabled(enabled) {
  try { localStorage.setItem(GEO_GLOBAL_KEY, enabled ? "true" : "false"); } catch { }
}
